import React, { useState, ReactNode, ReactElement, createContext, useContext } from 'react';

export type ModalContextType = {
  legacy: boolean;
  disableLegacy: () => void;
};
export const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModalContext = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) {
    throw new Error('Modal Context should be used inside the ModalContextProvider');
  }
  return ctx;
};

type ModalContextProviderProps = { children: ReactNode };

export const ModalContextProvider = ({ children }: ModalContextProviderProps): ReactElement => {
  const [legacy, setLegacy] = useState(true);

  const value: ModalContextType = {
    legacy,
    disableLegacy: () => setLegacy(false),
  };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};
